module.exports = __webpack_public_path__ + "static/media/purepapermetal.c560a69b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections/purepapermetal.jpg
// module id = 1151
// module chunks = 37